var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatTradeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 35,
    fontFamily: "system-ui, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "white"
  }, "cTrade")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTradeLogo);
export default __webpack_public_path__ + "static/media/ChatTradeLogo.d86ae42758050e0e4814d481c3a53efb.svg";
export { ForwardRef as ReactComponent };